import { RootState } from "@base/store";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  Avatar,
  CardContent,
  Container,
  ProfileCard,
  ProfileWrapper,
  UserName,
  UserNameAndProfileTagWrapper,
  ViewProfileTag,
} from "./profileToggle.styled";

import { ReactComponent as RightChevron } from "@assets/images/chevrons/chevron-right.svg";

const ProfileToggle = () => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.user.user);

  const stringAvatar = (name: string) => {
    return {
      children: `${name?.split(" ")[0][0]?.toUpperCase()}${name
        ?.split(" ")[1][0]
        ?.toUpperCase()}`,
    };
  };

  return (
    <Container
      onClick={() => {
        navigate("/profile");
      }}
    >
      <ProfileCard variant="outlined">
        <CardContent>
          <ProfileWrapper>
            {user?.profileImg ? (
              <Avatar alt="user Photo" src={user?.profileImg} />
            ) : (
              <Avatar
                alt="user Photo"
                {...stringAvatar(`${user?.firstName} ${user?.lastName}`)}
              />
            )}
            <UserNameAndProfileTagWrapper>
              <UserName>{user?.firstName}</UserName>
              <ViewProfileTag>View profile</ViewProfileTag>
            </UserNameAndProfileTagWrapper>
          </ProfileWrapper>
          <RightChevron />
        </CardContent>
      </ProfileCard>
    </Container>
  );
};

export { ProfileToggle };
